import { m as q, g as l, l as A, P as S, V as m, n as Z, M as J, o as Q, k, q as ee, r as re, e as te, t as ne, u as oe, h as ue, i as ie, v as ae } from "../../../getCountryByCallingCode-D_emPjr3.js";
function ce(e, r) {
  var t = Array.prototype.slice.call(r);
  return t.push(q), e.apply(this, t);
}
var fe = ";ext=", v = function(r) {
  return "([".concat(l, "]{1,").concat(r, "})");
};
function B(e) {
  var r = "20", t = "15", n = "9", o = "6", i = "[  \\t,]*", u = "[:\\.．]?[  \\t,-]*", a = "#?", c = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", f = "(?:[xｘ#＃~～]|int|ｉｎｔ)", y = "[- ]+", _ = "[  \\t]*", s = "(?:,{2}|;)", b = fe + v(r), O = i + c + u + v(r) + a, W = i + f + u + v(n) + a, z = y + v(o) + "#", K = _ + s + u + v(t) + a, Y = _ + "(?:,)+" + u + v(n) + a;
  return b + "|" + O + "|" + W + "|" + z + "|" + K + "|" + Y;
}
var le = "[" + l + "]{" + A + "}", se = "[" + S + "]{0,1}(?:[" + m + "]*[" + l + "]){3,}[" + m + l + "]*", pe = new RegExp("^[" + S + "]{0,1}(?:[" + m + "]*[" + l + "]){1,2}$", "i"), ye = se + // Phone number extensions
"(?:" + B() + ")?", be = new RegExp(
  // Either a short two-digit-only phone number
  "^" + le + "$|^" + ye + "$",
  "i"
);
function _e(e) {
  return e.length >= A && be.test(e);
}
function ve(e) {
  return pe.test(e);
}
function P(e) {
  "@babel/helpers - typeof";
  return P = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, P(e);
}
function Oe(e, r, t) {
  return Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function ge(e, r) {
  if (!(e instanceof r))
    throw new TypeError("Cannot call a class as a function");
}
function he(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), r && g(e, r);
}
function de(e) {
  var r = G();
  return function() {
    var n = h(e), o;
    if (r) {
      var i = h(this).constructor;
      o = Reflect.construct(n, arguments, i);
    } else
      o = n.apply(this, arguments);
    return me(this, o);
  };
}
function me(e, r) {
  if (r && (P(r) === "object" || typeof r == "function"))
    return r;
  if (r !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return V(e);
}
function V(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function E(e) {
  var r = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return E = function(n) {
    if (n === null || !Pe(n)) return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof r < "u") {
      if (r.has(n)) return r.get(n);
      r.set(n, o);
    }
    function o() {
      return d(n, arguments, h(this).constructor);
    }
    return o.prototype = Object.create(n.prototype, { constructor: { value: o, enumerable: !1, writable: !0, configurable: !0 } }), g(o, n);
  }, E(e);
}
function d(e, r, t) {
  return G() ? d = Reflect.construct : d = function(o, i, u) {
    var a = [null];
    a.push.apply(a, i);
    var c = Function.bind.apply(o, a), f = new c();
    return u && g(f, u.prototype), f;
  }, d.apply(null, arguments);
}
function G() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Pe(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function g(e, r) {
  return g = Object.setPrototypeOf || function(n, o) {
    return n.__proto__ = o, n;
  }, g(e, r);
}
function h(e) {
  return h = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, h(e);
}
var p = /* @__PURE__ */ function(e) {
  he(t, e);
  var r = de(t);
  function t(n) {
    var o;
    return ge(this, t), o = r.call(this, n), Object.setPrototypeOf(V(o), t.prototype), o.name = o.constructor.name, o;
  }
  return Oe(t);
}(/* @__PURE__ */ E(Error)), x = new RegExp("(?:" + B() + ")$", "i");
function Ee(e) {
  var r = e.search(x);
  if (r < 0)
    return {};
  for (var t = e.slice(0, r), n = e.match(x), o = 1; o < n.length; ) {
    if (n[o])
      return {
        number: t,
        ext: n[o]
      };
    o++;
  }
}
function Ne(e, r) {
  var t = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t) return (t = t.call(e)).next.bind(t);
  if (Array.isArray(e) || (t = we(e)) || r) {
    t && (e = t);
    var n = 0;
    return function() {
      return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function we(e, r) {
  if (e) {
    if (typeof e == "string") return R(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return R(e, r);
  }
}
function R(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function C(e) {
  for (var r = "", t = Ne(e.split("")), n; !(n = t()).done; ) {
    var o = n.value;
    r += Ae(o, r) || "";
  }
  return r;
}
function Ae(e, r, t) {
  return e === "+" ? r ? void 0 : "+" : Z(e);
}
var X = "+", Se = "[\\-\\.\\(\\)]?", T = "([" + l + "]|" + Se + ")", xe = "^\\" + X + T + "*[" + l + "]" + T + "*$", Re = new RegExp(xe, "g"), N = l, Ce = "[" + N + "]+((\\-)*[" + N + "])*", Te = "a-zA-Z", Ie = "[" + Te + "]+((\\-)*[" + N + "])*", Fe = "^(" + Ce + "\\.)*" + Ie + "\\.?$", je = new RegExp(Fe, "g"), I = "tel:", w = ";phone-context=", Le = ";isub=";
function De(e) {
  var r = e.indexOf(w);
  if (r < 0)
    return null;
  var t = r + w.length;
  if (t >= e.length)
    return "";
  var n = e.indexOf(";", t);
  return n >= 0 ? e.substring(t, n) : e.substring(t);
}
function Me(e) {
  return e === null ? !0 : e.length === 0 ? !1 : Re.test(e) || je.test(e);
}
function Ue(e, r) {
  var t = r.extractFormattedPhoneNumber, n = De(e);
  if (!Me(n))
    throw new p("NOT_A_NUMBER");
  var o;
  if (n === null)
    o = t(e) || "";
  else {
    o = "", n.charAt(0) === X && (o += n);
    var i = e.indexOf(I), u;
    i >= 0 ? u = i + I.length : u = 0;
    var a = e.indexOf(w);
    o += e.substring(u, a);
  }
  var c = o.indexOf(Le);
  if (c > 0 && (o = o.substring(0, c)), o !== "")
    return o;
}
var $e = 250, He = new RegExp("[" + S + l + "]"), Be = new RegExp("[^" + l + "#]+$");
function Ve(e, r, t) {
  if (r = r || {}, t = new J(t), r.defaultCountry && !t.hasCountry(r.defaultCountry))
    throw r.v2 ? new p("INVALID_COUNTRY") : new Error("Unknown country: ".concat(r.defaultCountry));
  var n = Xe(e, r.v2, r.extract), o = n.number, i = n.ext, u = n.error;
  if (!o) {
    if (r.v2)
      throw u === "TOO_SHORT" ? new p("TOO_SHORT") : new p("NOT_A_NUMBER");
    return {};
  }
  var a = ze(o, r.defaultCountry, r.defaultCallingCode, t), c = a.country, f = a.nationalNumber, y = a.countryCallingCode, _ = a.countryCallingCodeSource, s = a.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (r.v2)
      throw new p("INVALID_COUNTRY");
    return {};
  }
  if (!f || f.length < A) {
    if (r.v2)
      throw new p("TOO_SHORT");
    return {};
  }
  if (f.length > Q) {
    if (r.v2)
      throw new p("TOO_LONG");
    return {};
  }
  if (r.v2) {
    var b = new k(y, f, t.metadata);
    return c && (b.country = c), s && (b.carrierCode = s), i && (b.ext = i), b.__countryCallingCodeSource = _, b;
  }
  var O = (r.extended ? t.hasSelectedNumberingPlan() : c) ? ee(f, t.nationalNumberPattern()) : !1;
  return r.extended ? {
    country: c,
    countryCallingCode: y,
    carrierCode: s,
    valid: O,
    possible: O ? !0 : !!(r.extended === !0 && t.possibleLengths() && re(f, t)),
    phone: f,
    ext: i
  } : O ? We(c, f, i) : {};
}
function Ge(e, r, t) {
  if (e) {
    if (e.length > $e) {
      if (t)
        throw new p("TOO_LONG");
      return;
    }
    if (r === !1)
      return e;
    var n = e.search(He);
    if (!(n < 0))
      return e.slice(n).replace(Be, "");
  }
}
function Xe(e, r, t) {
  var n = Ue(e, {
    extractFormattedPhoneNumber: function(u) {
      return Ge(u, t, r);
    }
  });
  if (!n)
    return {};
  if (!_e(n))
    return ve(n) ? {
      error: "TOO_SHORT"
    } : {};
  var o = Ee(n);
  return o.ext ? o : {
    number: n
  };
}
function We(e, r, t) {
  var n = {
    country: e,
    phone: r
  };
  return t && (n.ext = t), n;
}
function ze(e, r, t, n) {
  var o = te(C(e), r, t, n.metadata), i = o.countryCallingCodeSource, u = o.countryCallingCode, a = o.number, c;
  if (u)
    n.selectNumberingPlan(u);
  else if (a && (r || t))
    n.selectNumberingPlan(r, t), r && (c = r), u = t || ne(r, n.metadata);
  else return {};
  if (!a)
    return {
      countryCallingCodeSource: i,
      countryCallingCode: u
    };
  var f = oe(C(a), n), y = f.nationalNumber, _ = f.carrierCode, s = ue(u, {
    nationalNumber: y,
    defaultCountry: r,
    metadata: n
  });
  return s && (c = s, s === "001" || n.country(c)), {
    country: c,
    countryCallingCode: u,
    countryCallingCodeSource: i,
    nationalNumber: y,
    carrierCode: _
  };
}
function F(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function j(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? F(Object(t), !0).forEach(function(n) {
      Ke(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : F(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Ke(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Ye(e, r, t) {
  return Ve(e, j(j({}, r), {}, {
    v2: !0
  }), t);
}
function L(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function qe(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? L(Object(t), !0).forEach(function(n) {
      Ze(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : L(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Ze(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Je(e, r) {
  return rr(e) || er(e, r) || ke(e, r) || Qe();
}
function Qe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ke(e, r) {
  if (e) {
    if (typeof e == "string") return D(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return D(e, r);
  }
}
function D(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function er(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], o = !0, i = !1, u, a;
    try {
      for (t = t.call(e); !(o = (u = t.next()).done) && (n.push(u.value), !(r && n.length === r)); o = !0)
        ;
    } catch (c) {
      i = !0, a = c;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (i) throw a;
      }
    }
    return n;
  }
}
function rr(e) {
  if (Array.isArray(e)) return e;
}
function tr(e) {
  var r = Array.prototype.slice.call(e), t = Je(r, 4), n = t[0], o = t[1], i = t[2], u = t[3], a, c, f;
  if (typeof n == "string")
    a = n;
  else throw new TypeError("A text for parsing must be a string.");
  if (!o || typeof o == "string")
    u ? (c = i, f = u) : (c = void 0, f = i), o && (c = qe({
      defaultCountry: o
    }, c));
  else if (ie(o))
    i ? (c = o, f = i) : f = o;
  else throw new Error("Invalid second argument: ".concat(o));
  return {
    text: a,
    options: c,
    metadata: f
  };
}
function M(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function U(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? M(Object(t), !0).forEach(function(n) {
      nr(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : M(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function nr(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function or(e, r, t) {
  r && r.defaultCountry && !ae(r.defaultCountry, t) && (r = U(U({}, r), {}, {
    defaultCountry: void 0
  }));
  try {
    return Ye(e, r, t);
  } catch (n) {
    if (!(n instanceof p)) throw n;
  }
}
function $(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function H(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? $(Object(t), !0).forEach(function(n) {
      ur(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function ur(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function ir() {
  var e = tr(arguments), r = e.text, t = e.options, n = e.metadata;
  t = H(H({}, t), {}, {
    extract: !1
  });
  var o = or(r, t, n);
  return o && o.isValid() || !1;
}
function ar() {
  return ce(ir, arguments);
}
class fr {
  validate(r, t) {
    const n = t.toUpperCase();
    return ar(r, n);
  }
}
export {
  fr as default
};
